const tags = new Set([
  'P',
  'DIV',
  'SPAN',
  'STRONG',
  'B',
  'EM',
  'I',
  'U',
  'S',
  'BR',
  'OL',
  'UL',
  'LI',
  'A'
]);
const blocked = new Set([
  'SCRIPT',
  'STYLE',
  'IFRAME',
  'OBJECT',
  'EMBED',
  'SVG',
  'MATH',
  'TEMPLATE'
]);

/** Guides allow text formatting and links; media belongs to the typed attachment list. */
export const sanitizeGuideHtml = (html: string): string => {
  const input = document.createElement('template');
  input.innerHTML = html;
  const output = document.createElement('div');
  const append = (source: Node, parent: Node) => {
    if (source.nodeType === Node.TEXT_NODE) {
      parent.appendChild(document.createTextNode(source.textContent || ''));
      return;
    }
    if (!(source instanceof HTMLElement) || blocked.has(source.tagName)) return;
    const element = tags.has(source.tagName)
      ? document.createElement(source.tagName.toLowerCase())
      : document.createDocumentFragment();
    if (source.tagName === 'A' && element instanceof HTMLElement) {
      const href = source.getAttribute('href') || '';
      if (/^(https?:\/\/|mailto:)/i.test(href)) {
        element.setAttribute('href', href);
        element.setAttribute('rel', 'noopener noreferrer');
        element.setAttribute('target', '_blank');
      }
    }
    source.childNodes.forEach((child) => append(child, element));
    parent.appendChild(element);
  };
  input.content.childNodes.forEach((node) => append(node, output));
  return output.innerHTML;
};

export const guideAsHtml = (value: string, format?: 'text' | 'html') => {
  if (format === 'html') return sanitizeGuideHtml(value);
  const node = document.createElement('div');
  node.textContent = value;
  return node.innerHTML.replace(/\n/g, '<br>');
};
